import * as React from 'react';
import { cn } from '../../lib/cn';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export function Button({ className, variant = 'primary', ...props }: ButtonProps) {
  const variants: Record<ButtonVariant, string> = {
    primary: 'bg-[hsl(var(--ui-primary))] text-[hsl(var(--ui-primary-foreground))]',
    secondary: 'bg-[hsl(var(--ui-muted))] text-[hsl(var(--ui-foreground))]',
    ghost: 'bg-transparent hover:bg-[hsl(var(--ui-accent))]',
  };

  return (
    <button
      className={cn(
        'inline-flex h-8 items-center justify-center rounded-[var(--ui-radius-control)] px-3 text-[13px] font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-ring)/0.35)] disabled:opacity-50',
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
